module.exports = __webpack_public_path__ + "packs/media/images/climber_man_70x70-58dcf8a67cb6af8be567e07e480618e7.jpg";